import React, { useState } from 'react';
import './PremiumAccessPage.css';
import { useNavigate } from 'react-router-dom';
import { usePremium } from '../hooks/usePremium.ts';
import { useAuth } from '../context/AuthContext.tsx';
import LoginModal from './auth/LoginModal.tsx';

const PremiumAccessPage: React.FC = () => {

  const navigate = useNavigate();
  const isPremium = usePremium();
  const { isAuthenticated } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);

  if (isPremium) return null;

  if (!isAuthenticated) {
    return (
      <>
        <div className="premium-access-wrapper">
          <div className="premium-access-card">
            <div className="premium-icon">🔒</div>
            <h2 className="premium-title">Login Required</h2>
            <p className="premium-message">
              Sign in to explore stock patterns identified by our AI screeners.
            </p>
            <button className="premium-button" onClick={() => setShowLoginModal(true)}>
              Sign In
            </button>
          </div>
        </div>
        <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
      </>
    );
  }

  return (
    <div className="premium-access-wrapper">
      <div className="premium-access-card">
        <div className="premium-icon">⭐</div>
        <h2 className="premium-title">Premium Feature</h2>
        <p className="premium-message">
          This feature is available only to <strong>subscribed users</strong>.
          Upgrade your plan to unlock it.
        </p>
        <button className="premium-button" onClick={() => navigate('/pricing')}>
          🔓 Subscribe Now
        </button>
      </div>
    </div>
  );
};

export default PremiumAccessPage;
